module.exports = __webpack_public_path__ + "cut-img.jpg?df4815ac04b2be5539e7c4c0e9cb34df";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cut-img.jpg
// module id = 56
// module chunks = 0